import { faAddressBook, faBookmark, faBooks, faBoxesStacked, faChartLine, faClipboardListCheck, faCog, faDolly, faHomeLgAlt, faUsers } from '@fortawesome/pro-light-svg-icons'
import { ConnectedProps, connect } from 'react-redux'
import { AppLayoutLoaded } from '../../baseComponents/AppLayout'
import CreateRoutering from '../../baseComponents/CreateRoutering'
import { cleanRoutes } from '../../baseComponents/CreateRoutering/functions'
import { Routes } from '../../baseComponents/CreateRoutering/types'
import useTwinTranslation from '../../utils/hooks/useTwinTranslation'
import { AllReduxAppPayloads, GlobalContext } from '../../utils/reducers'
import ErpLoader from './components/ErpLoader'
import ActivateFingerprintInner from './screens/ActivateFingerprintInner'
import EmployeeProfile from './screens/BottomIcons/EmployeeProfile'
import Notifications from './screens/BottomIcons/Notifications'
import UserTimeControl from './screens/BottomIcons/UserTimeControl'
import CompanyDashboard from './screens/Company/CompanyDashboard'
import WorkingCenters from './screens/Company/CompanyParent/WorkingCenters'
import SingleWorkingCenter from './screens/Company/CompanyParent/WorkingCenters/SingleWorkingCenter'
import Sues from './screens/Company/Sues'
import ConfigParameters from './screens/Config/ConfigParameters'
import Employees from './screens/Staff/EmployeeParent/Employees'
import SingleEmployee from './screens/Staff/EmployeeParent/Employees/SingleEmployee'
import GroupEmployees from './screens/Staff/EmployeeParent/GroupEmployees'
import PermissionGroup from './screens/Staff/EmployeeParent/GroupEmployees/PermissionsGroup'
import StaffDashboard from './screens/Staff/StaffDashboard'
import EmployeeAbsencesRequests from './screens/Staff/WorkingCalendarParent/EmployeeAbsencesRequests'
import EmployeeAbsenceTypes from './screens/Staff/WorkingCalendarParent/EmployeeAbsencesTypes'
import TimeControlEmployeeMonth from './screens/Staff/WorkingCalendarParent/TimeControlEmployeeMonth'
import WorkingCalendarFree from './screens/Staff/WorkingCalendarParent/WorkingCalendarFree'
import WorkingCalendarFreeDays from './screens/Staff/WorkingCalendarParent/WorkingCalendarFree/WorkingCalendarFreeDays'
import WorkingCalendarHolidayBag from './screens/Staff/WorkingCalendarParent/WorkingCalendarHolidayBag'
import WorkingCalendarHolidayRequests from './screens/Staff/WorkingCalendarParent/WorkingCalendarHolidayRequests'
import WorkingCalendarSpecial from './screens/Staff/WorkingCalendarParent/WorkingCalendarSpecial'
import WorkingCalendarSpecialDays from './screens/Staff/WorkingCalendarParent/WorkingCalendarSpecial/WorkingCalendarSpecialDays'
import WorkingCalendars from './screens/Staff/WorkingCalendarParent/WorkingCalendars'
import SingleWorkingCalendar from './screens/Staff/WorkingCalendarParent/WorkingCalendars/SingleWorkingCalendar'
import CustomerProjectTypes from './screens/Company/CustomerParent/CustomerProjectTypes'
import Customers from './screens/Company/CustomerParent/Customers'
import SingleCustomer from './screens/Company/CustomerParent/Customers/SingleCustomer'
import CustomersB2B from './screens/Company/CustomerParent/CustomersB2B'
import SingleCustomerB2B from './screens/Company/CustomerParent/CustomersB2B/SingleCustomerB2B'
import GroupsCustomers from './screens/Company/CustomerParent/GroupsCustomers'
import TaskCustomFields from './screens/Company/Tasks/TaskCustomFields'
import TaskTypes from './screens/Company/Tasks/TaskTypes'
import TaskBagOfHours from './screens/Company/Tasks/TaskBagOfHours'
import TaskCalendarAdmin from './screens/Company/Tasks/TaskCalendarAdmin'
import CustomerProjectTypesStatusesFlow from './screens/Company/CustomerParent/CustomerProjectFlow'
import TasksSummary from './screens/Company/Tasks/TasksSummary'
import TasksByEmployee from './screens/Company/Tasks/TasksTableEmployees/TasksByEmployee'
import TasksTableGroups from './screens/Company/Tasks/TasksTableGroups'
import TaskByGroup from './screens/Company/Tasks/TasksTableGroups/TaskByGroup'
import TasksTableEmployees from './screens/Company/Tasks/TasksTableEmployees'
import UsersLogs from './screens/Company/CompanyParent/UsersLogs'
import ConfigCurrencies from './screens/Config/ConfigCurrencies'
import ExpensesRequest from './screens/Staff/ExpensesParent/ExpensesRequest'
import ExpensesTypes from './screens/Staff/ExpensesParent/ExpensesTypes'
import CustomerProjects from './screens/Company/CustomerParent/CustomerProjects'
import ConfigLangs from './screens/Config/ConfigLangs'
import SingleProduct from './screens/Logistic/ProductsParent/Products/SingleProduct'
import Products from './screens/Logistic/ProductsParent/Products'
import Categories from './screens/Logistic/ProductsParent/Categories'
import SpecificPriceRules from './screens/Logistic/ProductsParent/SpecificPriceRules'
import Suppliers from './screens/Logistic/SuppliersParent'
import SingleSupplier from './screens/Logistic/SuppliersParent/SingleSupplier'
import Brands from './screens/Logistic/ProductsParent/Brands'
import Features from './screens/Logistic/ProductsParent/Features'
import Variants from './screens/Logistic/ProductsParent/Variants'
import PriceZones from './screens/Logistic/ProductsParent/PriceZones'
import Packagings from './screens/Logistic/ProductsParent/Packagings'
import SinglePackaging from './screens/Logistic/ProductsParent/Packagings/SinglePackaging'
import Addons from './screens/Logistic/ProductsParent/Addons'
import SingleAddon from './screens/Logistic/ProductsParent/Addons/SingleAddon'
import ConfigServiceTypes from './screens/Config/ConfigServiceTypes'
import ConfigGroupVats from './screens/Config/ConfigGroupVats'
import ConfigSingleVat from './screens/Config/ConfigGroupVats/ConfigSingleVat'
import Creditors from './screens/Logistic/CreditorsParent'
import SingleCreditor from './screens/Logistic/CreditorsParent/SingleCreditor'
import ConfigShippingCompanies from './screens/Config/ConfigShipping/CShippingCompanies'
import SingleConfigShippingServiceConnect from './screens/Config/ConfigShipping/CShippingCompanies/CShippingServices/SingleCShippingService'
import ConfigShippingZones from './screens/Config/ConfigShipping/ConfigShippingZoneGroup'
import QuoteOrdersB2B from './screens/Logistic/QuoteParent/QuoteOrders'
import SingleQuoteOrderB2B from './screens/Logistic/QuoteParent/QuoteOrders/SingleQuoteOrder'
import ConfigCostSells from './screens/Config/ConfigCosts/ConfigCostSells'
import LogisticDashboard from './screens/Logistic/LogisticDashboard'
import MaterialCategories from './screens/Logistic/MaterialsParent/MaterialCategories'
import Materials from './screens/Logistic/MaterialsParent/Materials'
import SingleMaterial from './screens/Logistic/MaterialsParent/Materials/SingleMaterial'
import Warehouses from './screens/Logistic/Warehouses'
import SingleWarehouse from './screens/Logistic/Warehouses/SingleWarehouse'
import TaskRespositories from './screens/Company/Tasks/TaskRepositories'
import ConfigTemplateChecklists from './screens/Config/ConfigTemplateChecklists'
import CustomerOrigins from './screens/Company/CustomerParent/CustomerOrigins'
import FixWCal from './screens/FixWCal'
import GenerateQrCodes from './screens/Staff/WorkingCalendarParent/GenerateQrCodes'
import ContactsB2B from './screens/Company/CustomerParent/ContactsB2B'
import SingleContactB2B from './screens/Company/CustomerParent/ContactsB2B/SingleContactB2B'
import ContactsB2C from './screens/Company/CustomerParent/ContactsB2C'
import SingleContactB2C from './screens/Company/CustomerParent/ContactsB2C/SingleContactB2C'
import CustomerProjectFlow from './screens/Company/CustomerParent/CustomerProjectFlow/CustomerProjectFlowProps'
import ConfigPdfTemplates from './screens/Config/ConfigPdfTemplates'
import ConfigPdfTemplateSingle from './screens/Config/ConfigPdfTemplates/ConfigPdfTemplateSingle'
import Campaigns from './screens/Company/CustomerParent/Campaigns'
import SingleCampaign from './screens/Company/CustomerParent/Campaigns/SingleCampaign'
import TaskRespositoryTags from './screens/Company/Tasks/TaskRepositoryTags'
import WorkingCalendarOvertimeRequests from './screens/Staff/WorkingCalendarParent/WorkingCalendarOvertimeRequests'
import AllCustomers from './screens/Company/CustomerParent/AllCustomers'
import SingleAllCustomer from './screens/Company/CustomerParent/AllCustomers/SingleAllCustomer'
import { getConfigParam } from '../../utils/reducers/getters'
import { CompanyTypeOfCustomersTyInversed } from '@teinor/erp/types/company/config/parameter'
import Services from './screens/Logistic/ProductsParent/Services'
import SingleService from './screens/Logistic/ProductsParent/Services/SingleService'
import AddonCategories from './screens/Logistic/ProductsParent/AddonCategories'
import locations from '../../utils/globals/locations'
import TaskCFieldTypesStatusesFlow from './screens/Company/Tasks/TaskFlow'
import TaskFlow from './screens/Company/Tasks/TaskFlow/TaskFlowProps'
import WorkingCalendarTurns from './screens/Staff/WorkingCalendarParent/WorkingCalendarTurns'
import ConfigBillingGroups from './screens/Config/ConfigBillingGroups'
import ConfigBillingTypesBuy from './screens/Config/ConfigBillingGroups/ConfigBillingTypesBuy'
import ConfigBillingTypesSell from './screens/Config/ConfigBillingGroups/ConfigBillingTypeSells'
import ConfigBillingRetentions from './screens/Config/ConfigBillingGroups/ConfigBillingRetentions'
import SellDeliveryNotes from './screens/Logistic/QuoteParent/SellParent/SellDeliveryNotes'
import SingleSellDeliveryNote from './screens/Logistic/QuoteParent/SellParent/SellDeliveryNotes/SingleSellDN'
import SellInvoices from './screens/Logistic/QuoteParent/SellParent/SellInvoices'
import SingleSellInvoice from './screens/Logistic/QuoteParent/SellParent/SellInvoices/SingleSellInvoice'
import SingleSellOrder from './screens/Logistic/QuoteParent/SellParent/SellOrders/SingleSellOrder'
import SellTags from './screens/Logistic/QuoteParent/SellParent/SellTags'
import SellOrders from './screens/Logistic/QuoteParent/SellParent/SellOrders'
import VatRepercuted from './screens/Logistic/VatRepercutedParent'
import SingleVatRepercuted from './screens/Logistic/VatRepercutedParent/SingleVatRepercuted'
import BuyTags from './screens/Logistic/BuyParent/BuyTags'
import ConfigCostBuys from './screens/Config/ConfigCosts/ConfigCostBuys'
import BuyOrders from './screens/Logistic/BuyParent/BuyOrders'
import SingleBuyOrder from './screens/Logistic/BuyParent/BuyOrders/SingleBuyOrder'
import BuyDeliveryNotes from './screens/Logistic/BuyParent/BuyDeliveryNotes'
import SingleBuyDeliveryNote from './screens/Logistic/BuyParent/BuyDeliveryNotes/SingleBuyDeliveryNote'
import BuyInvoices from './screens/Logistic/BuyParent/BuyInvoices'
import SingleBuyInvoice from './screens/Logistic/BuyParent/BuyInvoices/SingleBuyInvoice'
import VatSupported from './screens/Logistic/VatSupportedParent'
import SingleVatSupported from './screens/Logistic/VatSupportedParent/SingleVatSupported'
import ConfigSellVariables from './screens/Config/ConfigSellVariables'
import WorkSheetGroupStatus from './screens/Logistic/ProductsParent/Orders/WorkSheetGroupStatuses'
import WorkSheets from './screens/Logistic/QuoteParent/SellParent/WorkSheets'
import SingleWorkSheet from './screens/Logistic/QuoteParent/SellParent/WorkSheets/SingleWorkSheet'
import WorkSheetsProductStatusView from './screens/Logistic/QuoteParent/SellParent/WorkSheets/WorkSheetsProductStatusView'
import ConfigLabels from './screens/Config/ConfigLabels'
import { useMemo } from 'react'
import { BookMarkRoutesParsedTy } from './types'
import { TwinDictionary } from '../../utils/globals/dictionary'
import ProductTypes from './screens/Logistic/ProductsParent/ProductTypes'
import GenerateMultiSellInvoices from './screens/Logistic/QuoteParent/SellParent/SellInvoices/GenerateMultiSellInvoices'
import GenerateMultiSellDeliveryNote from './screens/Logistic/QuoteParent/SellParent/SellDeliveryNotes/GenerateMultiSellDN'
import CreateMultiSellDeliveryNotes from './screens/Logistic/QuoteParent/SellParent/SellDeliveryNotes/GenerateMultiSellDN/CreateMultiSellDN'
import CreateMultiSellInvoicesFromDN from './screens/Logistic/QuoteParent/SellParent/SellInvoices/GenerateMultiSellInvoices/CreateMultiSellInvoiceFromDN'
import CreateMultiSellInvoicesFromOrders from './screens/Logistic/QuoteParent/SellParent/SellInvoices/GenerateMultiSellInvoices/CreateMultiSellInvoiceFromOrders'
import ConfigCsvOrderTemplates from './screens/Config/ConfigCsvOrderTemplates'
import SellInvoicesRefund from './screens/Logistic/QuoteParent/SellParent/SellInvoiceRefunds'
import SingleSellInvoiceRefund from './screens/Logistic/QuoteParent/SellParent/SellInvoiceRefunds/SingleSellInvoiceRefund'
import GenerateMultiSellInvoicesRefund from './screens/Logistic/QuoteParent/SellParent/SellInvoiceRefunds/GenerateMultiSellInvoicesRefund'
import CreateMultiSellInvoiceRefund from './screens/Logistic/QuoteParent/SellParent/SellInvoiceRefunds/GenerateMultiSellInvoicesRefund/CreateMultiSellInvoiceRefund'
import SellAllStats from './screens/Logistic/QuoteParent/SellAllStats'
import ConfigPaymentMethods from './screens/Config/ConfigPaymentMethods'
import ConfigPaymentTypes from './screens/Config/ConfigPaymentTypes'
import SellDeliveryNotesRefund from './screens/Logistic/QuoteParent/SellParent/SellDeliveryNoteRefunds'
import SingleSellDeliveryNoteRefund from './screens/Logistic/QuoteParent/SellParent/SellDeliveryNoteRefunds/SingleSellDeliveryNoteRefund'
import GenerateMultiSellDeliveryNotesRefund from './screens/Logistic/QuoteParent/SellParent/SellDeliveryNoteRefunds/GenerateMultiSellDeliveryNoteRefund'
import CreateMultiSellDeliveryNoteRefund from './screens/Logistic/QuoteParent/SellParent/SellDeliveryNoteRefunds/GenerateMultiSellDeliveryNoteRefund/CreateMultiSellDeliveryNoteRefund'
import TPVDashboard from './screens/TPV/TPVDashboard'
import SellTickets from './screens/Logistic/QuoteParent/SellParent/SellTickets'
import SellTicketFinishedStep from './screens/Logistic/QuoteParent/SellParent/SellTickets/SingleSellTicket'
import CustomerOpportunities from './screens/Company/CustomerParent/CustomerOpportunities'
import CustomerOpportunitiesFlow from './screens/Company/CustomerParent/AllCustomers/CustomerOpportunitiesFlow'
import CustomerOpportunitiesStatusFlow from './screens/Company/CustomerParent/AllCustomers/CustomerOpportunitiesFlow/CustomerOpportunitiesStatusFlow'
import CollectionAndPayments from './screens/Logistic/Accounting/CollectionAndPayments'
import Remittances from './screens/Logistic/Accounting/CollectionAndPayments/Remittances'
import CustomerContacts from './screens/Company/CustomerParent/CustomerContacts'
import Vouchers from './screens/Logistic/QuoteParent/SellParent/Vouchers'
import AdjustmentDNs from './screens/Logistic/ProductsParent/AdjustmentDN'
import SingleAdjustmentDN from './screens/Logistic/ProductsParent/AdjustmentDN/SingleAdjustmentDN'
import CashRegisters from './screens/Logistic/QuoteParent/SellParent/CashRegisters'
import Collections from './screens/Logistic/ProductsParent/Collections'

export const ErpRoutesPaths = (EmployeeId?: number): Routes => {
    const { t } = useTwinTranslation()
    const now = new Date()
    const showAllCustomersTogether = getConfigParam('showAllCustomersTogether') === 'on' ? true : false 
    const haveLeads = getConfigParam('haveLeads') === 'on' ? true : false 
    const companyTypeOfCustomers = getConfigParam('companyTypeOfCustomers')
    const parsedCTypeOfCustomers = parseInt(String(companyTypeOfCustomers))
    return [
        {
            link: '/crm',
            text: t('CRM', 'CRM'),
            icon: faAddressBook,
            modules: ['tasks', 'quotes'],
            classNameIcon: ' fa-flip-horizontal',
            childs: [
                {
                    link: '/contacts',
                    text: t('contacts', 'Contactos'),
                    modules: ['tasks'],
                    to: showAllCustomersTogether ? locations.allCustomers : parsedCTypeOfCustomers === 2 ? locations.customerB2B : locations.customerB2C,
                    childs: [
                        {
                            link: '/allCustomers',
                            text: t('customers', 'Clientes'),
                            component: AllCustomers,
                            permissions: 'customer.profile.main',
                            modules: ['tasks'],
                            hidden: !showAllCustomersTogether,
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('customer', 'Cliente'),
                                    component: SingleAllCustomer,
                                    permissions: ['customer.profile.main', 'customer.profile.address', 'customer.profile.bank', 'customer.profile.contactPerson', 'customer.profile.files', 'customer.profile.projects', 'customer.profile.shops', 'customer.profile.bagOfHours', 'customer.profile.gdpr', 'customer.profile.tasks', 'customer.profile.campaign', 'customer.profile.notes', 'customer.profile.quotes', 'customer.profile.billingGroup', 'customer.profile.materialStock'],
                                }
                            ]
                        },
                        {
                            link: '/customers',
                            text: t('customers', 'Clientes'),
                            component: Customers,
                            permissions: 'customer.profile.main',
                            modules: ['tasks'],
                            hidden: showAllCustomersTogether || parsedCTypeOfCustomers === CompanyTypeOfCustomersTyInversed['B2B'],
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('customerB2C', 'Cliente B2C'),
                                    component: SingleCustomer,
                                    permissions: ['customer.profile.main', 'customer.profile.address', 'customer.profile.bank', 'customer.profile.contactPerson', 'customer.profile.files', 'customer.profile.projects', 'customer.profile.shops', 'customer.profile.bagOfHours', 'customer.profile.gdpr', 'customer.profile.tasks', 'customer.profile.campaign', 'customer.profile.notes', 'customer.profile.quotes', 'customer.profile.billingGroup', 'customer.profile.materialStock'],
                                }
                            ]
                        },
                        {
                            link: '/customersB2B',
                            text: t('customersB2B', 'Clientes B2B'),
                            component: CustomersB2B,
                            permissions: 'customer.profile.main',
                            hidden: showAllCustomersTogether || parsedCTypeOfCustomers === CompanyTypeOfCustomersTyInversed['B2C'],
                            modules: ['tasks'],
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('customerB2B', 'Cliente B2B'),
                                    component: SingleCustomerB2B,
                                    permissions: ['customer.profile.main', 'customer.profile.address', 'customer.profile.bank', 'customer.profile.contactPerson', 'customer.profile.files', 'customer.profile.projects', 'customer.profile.shops', 'customer.profile.bagOfHours', 'customer.profile.gdpr', 'customer.profile.tasks', 'customer.profile.campaign', 'customer.profile.notes', 'customer.profile.quotes', 'customer.profile.billingGroup', 'customer.profile.materialStock']
                                }
                            ]
                        },
                        {
                            link: '/contacts',
                            text: t('leads', 'Potenciales'),
                            component: ContactsB2C,
                            permissions: 'customer.profile.main',
                            modules: ['tasks'],
                            hidden: showAllCustomersTogether || parsedCTypeOfCustomers === CompanyTypeOfCustomersTyInversed['B2B'] || !haveLeads,
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('leadB2C', 'Potencial B2C'),
                                    component: SingleContactB2C,
                                    permissions: ['customer.profile.main', 'customer.profile.address', 'customer.profile.bank', 'customer.profile.contactPerson', 'customer.profile.files', 'customer.profile.projects', 'customer.profile.shops', 'customer.profile.bagOfHours', 'customer.profile.gdpr', 'customer.profile.tasks', 'customer.profile.campaign', 'customer.profile.notes', 'customer.profile.quotes', 'customer.profile.billingGroup', 'customer.profile.materialStock']
                                }
                            ]
                        },
                        {
                            link: '/contactsB2B',
                            text: t('leadsB2B', 'Potenciales B2B'),
                            component: ContactsB2B,
                            permissions: 'customer.profile.main',
                            modules: ['tasks'],
                            hidden: showAllCustomersTogether || parsedCTypeOfCustomers === CompanyTypeOfCustomersTyInversed['B2C'] || !haveLeads,
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('leadB2B', 'Potencial B2B'),
                                    component: SingleContactB2B,
                                    permissions: ['customer.profile.main', 'customer.profile.address', 'customer.profile.bank', 'customer.profile.contactPerson', 'customer.profile.files', 'customer.profile.projects', 'customer.profile.shops', 'customer.profile.bagOfHours', 'customer.profile.gdpr', 'customer.profile.tasks', 'customer.profile.campaign', 'customer.profile.notes', 'customer.profile.quotes', 'customer.profile.billingGroup', 'customer.profile.materialStock']
                                }
                            ]
                        },
                        {
                            link: '/people',
                            text: t('people', 'Personas'),
                            component: CustomerContacts,
                            permissions: ['contactPerson','customer.profile.main'],
                            modules: ['tasks'],
                        },
                    ],
                },
                {
                    link: '/opportunities',
                    text: t('opportunities', 'Oportunidades'),
                    to: locations.quoteListing,
                    childs: [
                        {
                            link: '/quotes',
                            text: t('quoteOrders', 'Presupuestos'),
                            component: QuoteOrdersB2B,
                            permissions: 'quote.order',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('quotes', 'Presupuestos'),
                                    component: SingleQuoteOrderB2B,
                                    permissions: ['quote.order']
                                }
                            ]
                        },
                        {
                            link: '/customerOpportunities',
                            text: t('opportunities', 'Oportunidades'),
                            component: CustomerOpportunities,
                            permissions: 'customer.projects.main',
                            modules: ['tasks'],
                        },
                        {
                            link: '/opportunitiesStatusFlow',
                            text: t('opportunitiesBoards', 'Tableros de oportunidades'),
                            component: CustomerOpportunitiesFlow,
                            permissions: 'customer.projects.main',
                            modules: ['tasks'],
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('board', 'Tablero'),
                                    component: CustomerOpportunitiesStatusFlow,
                                    permissions: 'customer.projects.main'
                                }
                            ]
                        },
                        {
                            link: '/campaigns',
                            text: t('campaigns', 'Campañas'),
                            component: Campaigns,
                            permissions: 'customer.campaigns.inner',
                            modules: ['tasks'],
                            childs: [
                                {
                                    link: '/:id',
                                    text: t('campaignCustomers', 'Clientes de la campaña'),
                                    component: SingleCampaign,
                                    permissions: 'customer.campaigns.inner',
                                    modules: ['tasks'],
                                }
                            ]
                        },
                    ]
                }
            ]
        },
        {
            link: '/sells',
            text: t('sells', 'Ventas'),
            component: LogisticDashboard,
            icon: faChartLine,
            childs: [
                {
                    text: t('pointOfSell', 'Punto de venta'),
                    modules: ['tpv'],
                    link: '/pointOfSale',
                    to: locations.tpv,
                    childs: [
                        {
                            link: '/tpv',
                            text: t('tpv', 'TPV'),
                            component: TPVDashboard
                        },
                        {
                            link: '/sellTickets',
                            text: t('tickets', 'Tickets'),
                            component: SellTickets,
                            permissions: 'sell.tickets',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('ticket', 'Ticket'),
                                    component: SellTicketFinishedStep,
                                    permissions: ['sell.tickets']
                                },
                            ]
                        },
                        {
                            link: '/vouchers',
                            text: t('vouchers', 'Vales'),
                            component: Vouchers,
                            permissions: 'sellOther.seeAllVouchers',
                        },
                        {
                            link: '/cashRegisters',
                            text: t('cashRegisters', 'Registros de caja'),
                            component: CashRegisters,
                            permissions: 'sellOther.seeAllCashSells',
                        },
                    ]
                },
                {
                    link: '/billing',
                    text: t('Billing', 'Facturación'),
                    modules: ['quotes'],
                    to: locations.sellInvoices,
                    childs: [
                        {
                            link: '/sellOrders',
                            text: t('orders', 'Pedidos'),
                            component: SellOrders,
                            permissions: 'sell.order',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('sellOrder', 'Pedido'),
                                    component: SingleSellOrder,
                                    permissions: ['sell.order']
                                }
                            ]
                        },
                        {
                            link: '/sellDeliveryNotes',
                            text: t('deliveryNotes', 'Albaranes'),
                            component: SellDeliveryNotes,
                            permissions: 'sell.deliveryNote',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('deliveryNote', 'Albarán'),
                                    component: SingleSellDeliveryNote,
                                    permissions: ['sell.deliveryNote']
                                },
                                {
                                    link: '/customersOrders',
                                    text: t('generateSellDeliveryNotes', 'Generar Albarán múltiple'),
                                    permissions: ['sell.multi.deliveryNote', 'sell.deliveryNote'],
                                    to: '/customersDeliveryNotes/main',
                                    childs: [
                                        {
                                            link: '/:CustomerId',
                                            text: t('byProvider', 'Por proveedor'),
                                            component: GenerateMultiSellDeliveryNote,
                                            permissions: ['sell.multi.deliveryNote', 'sell.deliveryNote'],
                                        },
                                        {
                                            link: '/generate/:ids',
                                            text: t('createSellDeliveryNote', 'Crear albarán de venta'),
                                            component: CreateMultiSellDeliveryNotes,
                                            permissions: ['sell.multi.deliveryNote', 'sell.deliveryNote']
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            link: '/sellInvoices',
                            text: t('invoices', 'Facturas'),
                            component: SellInvoices,
                            permissions: 'sell.invoice',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('invoice', 'Factura'),
                                    component: SingleSellInvoice,
                                    permissions: ['sell.invoice']
                                },
                                {
                                    link: '/customersDeliveryNotes',
                                    text: t('generateSellInvoices', 'Generar factura múltiple'),
                                    permissions: 'sell.multi.invoice',
                                    to: '/customersDeliveryNotes/main',
                                    childs: [
                                        {
                                            link: '/:CustomerId',
                                            text: t('byProvider', 'Por proveedor'),
                                            component: GenerateMultiSellInvoices,
                                            permissions: 'sell.multi.invoice',
                                        },
                                        {
                                            link: '/generateFromDN/:ids',
                                            text: t('createSellInvoice', 'Crear factura de venta'),
                                            component: CreateMultiSellInvoicesFromDN,
                                            permissions: 'sell.multi.invoice',
                                        },
                                        {
                                            link: '/generateFromOrders/:ids',
                                            text: t('createSellInvoice', 'Crear factura de venta'),
                                            component: CreateMultiSellInvoicesFromOrders,
                                            permissions: 'sell.multi.invoice',
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            link: '/sellDeliveryNotesRefund',
                            text: t('deliveryNotesRefund', 'Devolución de albaranes'),
                            component: SellDeliveryNotesRefund,
                            permissions: 'sell.refundDeliveryNote',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('deliveryNoteRefund', 'Devolución de albarán'),
                                    component: SingleSellDeliveryNoteRefund,
                                    permissions: ['sell.refundDeliveryNote']
                                },
                                {
                                    link: '/customersSellDeliveryNote',
                                    text: t('generateSellDeliveryNoteRefundMultiple', 'Generar devolución de albarán múltiple'),
                                    permissions: 'sell.refundDeliveryNote',
                                    to: '/customersSellDeliveryNote/main',
                                    childs: [
                                        {
                                            link: '/:CustomerId',
                                            text: t('byCustomer', 'Por cliente'),
                                            component: GenerateMultiSellDeliveryNotesRefund,
                                            permissions: 'sell.refundDeliveryNote',
                                        },
                                        {
                                            link: '/generateFromDeliveryNote/:ids',
                                            text: t('createSellDeliveryNoteRefund', 'Crear devolución de albarán de venta'),
                                            component: CreateMultiSellDeliveryNoteRefund,
                                            permissions: 'sell.refundDeliveryNote',
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            link: '/sellInvoicesRefund',
                            text: t('invoicesRefund', 'Devolución de facturas'),
                            component: SellInvoicesRefund,
                            permissions: 'sell.refundInvoice',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('invoiceRefund', 'Devolución de factura'),
                                    component: SingleSellInvoiceRefund,
                                    permissions: ['sell.refundInvoice']
                                },
                                {
                                    link: '/customersSellInvoice',
                                    text: t('generateSellInvoiceRefundMultiple', 'Generar devolución de factura múltiple'),
                                    permissions: 'sell.refundInvoice',
                                    to: '/customersSellInvoice/main',
                                    childs: [
                                        {
                                            link: '/:CustomerId',
                                            text: t('byCustomer', 'Por cliente'),
                                            component: GenerateMultiSellInvoicesRefund,
                                            permissions: 'sell.refundInvoice',
                                        },
                                        {
                                            link: '/generateFromInvoice/:ids',
                                            text: t('createSellInvoiceRefund', 'Crear devolución de factura de venta'),
                                            component: CreateMultiSellInvoiceRefund,
                                            permissions: 'sell.refundInvoice',
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            link: '/workSheets',
                            text: t('workSheets', 'Hojas de trabajo'),
                            component: WorkSheets,
                            permissions: ['sell.workSheetProductStatus'],
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('workSheet', 'Hoja de trabajo'),
                                    component: SingleWorkSheet,
                                    permissions: ['sell.workSheetProductStatus']
                                },
                                {
                                    link: '/statusFlow/:id',
                                    text: t('workSheets', 'Hojas de trabajo'),
                                    component: WorkSheetsProductStatusView,
                                    permissions: 'sell.workSheetProductStatus'
                                }
                            ]
                        }
                    ],
                },
                {
                    text: t('stats', 'Estadísticas'),
                    permissions: ['quote.stats', 'sell.stats'],
                    link: '/stats',
                    childs: [
                        {
                            link: '/stats',
                            text: t('stats', 'Estadísticas'),
                            component: SellAllStats,
                            permissions: ['quote.stats', 'sell.stats'],
                        },
                    ]
                }
            ]
        },
        {
            link: '/sat',
            text: t('Tasks', 'Tareas'),
            icon: faClipboardListCheck,
            component: CompanyDashboard,
            childs: [
                {
                    link: '/task',
                    text: t('tasks', 'Tareas'),
                    component: TasksSummary,
                    permissions: 'task.main',
                    modules: ['tasks'],
                    to: locations.task + '/main',
                    childs: [
                        {
                            link: `/myTask/:EmployeeId/:id`,
                            text: t('myTasks', 'Mis Tareas'),
                            component: TasksByEmployee,
                            permissions: 'task.main',
                            to: `${locations.myTask}/${EmployeeId}/main`,
                        },
                        {
                            link: '/tasks/:id',
                            text: t('tasks', 'Tareas'),
                            component: TasksSummary,
                            permissions: 'task.main',
                            to: locations.tasksMain
                        },
                        {
                            link: '/taskCalendar',
                            text: t('taskCalendar', 'Calendario de tareas'),
                            component: TaskCalendarAdmin,
                            permissions: 'task.main'
                        },
                        {
                            link: '/employees',
                            text: t('employeeTasks', 'Tareas del empleado'),
                            component: TasksTableEmployees,
                            permissions: 'task.main',
                            childs: [
                                {
                                    link: '/:EmployeeId/:id',
                                    text: t('employeeTasks', 'Tareas del empleado'),
                                    component: TasksByEmployee,
                                    permissions: 'task.main',
                                }
                            ]
                        },
                        {
                            link: '/groups',
                            text: t('groupTasks', 'Tareas por equipo'),
                            component: TasksTableGroups,
                            permissions: 'task.main',
                            childs: [
                                {
                                    link: '/:GroupId/:id',
                                    text: t('groupTasks', 'Tareas del Equipo'),
                                    component: TaskByGroup,
                                    permissions: 'task.main',
                                }
                            ]
                        },
                        {
                            link: '/taskBagOfHours',
                            text: t('bagsOfHours', 'Bolsas de horas'),
                            component: TaskBagOfHours,
                            permissions: 'task.bagOfHours'
                        },
                        {
                            link: '/taskFlow',
                            text: t('taskBoards', 'Tableros de tareas'),
                            component: TaskCFieldTypesStatusesFlow,
                            permissions: 'task.main',
                            modules: ['tasks'],
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('board', 'Tablero'),
                                    component: TaskFlow,
                                    permissions: 'task.main'
                                }
                            ]
                        },
                    ]
                },
                {
                    link: '/projects',
                    text: t('Proyectos', 'Proyectos'),
                    modules: ['tasks'],
                    to: locations.customerProjects,
                    childs: [
                        {
                            link: '/customerProjects',
                            text: t('projects', 'Proyectos'),
                            component: CustomerProjects,
                            permissions: 'customer.projects.main',
                            modules: ['tasks'],
                        },
                        {
                            link: '/projectStatusFlow',
                            text: t('projectBoards', 'Tableros de proyectos'),
                            component: CustomerProjectTypesStatusesFlow,
                            permissions: 'customer.projects.main',
                            modules: ['tasks'],
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('board', 'Tablero'),
                                    component: CustomerProjectFlow,
                                    permissions: 'customer.projects.main'
                                }
                            ]
                        },
                    ]
                },
                {
                    link: '/documentation',
                    text: t('documentation', 'Documentación'),
                    component: TaskRespositories,
                    permissions: 'task.repository',
                    modules: ['tasks'],
                    childs: [
                        {
                            link: '/taskRepositories',
                            text: t('repository', 'Repositorio'),
                            component: TaskRespositories,
                            permissions: 'task.repository',
                        },
                    ]
                },
            ]
        },
        {
            link: '/catalog',
            text: t('catalog', 'Catálogo'),
            icon: faBoxesStacked,
            modules: ['products'],
            childs: [
                {
                    link: '/product',
                    text: t('products', 'Productos'),
                    component: Products,
                    permissions: 'product.profile.main',
                    modules: ['products'],
                    childs: [
                        {
                            link: '/products',
                            text: t('products', 'Productos'),
                            component: Products,
                            permissions: 'product.profile.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('product', 'Producto'),
                                    component: SingleProduct,
                                    permissions: ['product.profile.main', 'product.profile.features', 'product.profile.supplier', 'product.profile.specificPrice', 'product.profile.stock', 'product.profile.variant', 'product.profile.productComposed', 'product.profile.lot', 'product.profile.serialized', 'product.profile.productAddon', 'product.profile.otherInformation', 'product.profile.web', 'product.profile.sells']
                                }
                            ]
                        },
                        {
                            link: '/packaging',
                            text: t('packagings', 'Packagings'),
                            component: Packagings,
                            permissions: 'product.packaging.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('packaging', 'Packaging'),
                                    component: SinglePackaging,
                                    permissions: ['product.packaging.main', 'product.packaging.supplier', 'product.packaging.specificPrice', 'product.packaging.stock', 'product.packaging.productComposed', 'product.packaging.otherInformation']
                                }
                            ]
                        },
                        {
                            link: '/addon',
                            text: t('addons', 'Complementos'),
                            component: Addons,
                            permissions: 'product.addon.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('addon', 'Complemento'),
                                    component: SingleAddon,
                                    permissions: ['product.addon.main', 'product.addon.supplier', 'product.addon.specificPrice', 'product.addon.stock', 'product.addon.otherInformation']
                                }
                            ]
                        },
                        {
                            link: '/materials',
                            text: t('materials', 'Materiales'),
                            component: Materials,
                            permissions: 'product.material.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('product', 'Producto'),
                                    component: SingleMaterial,
                                    permissions: ['product.material.main', 'product.material.supplier', 'product.material.specificPrice', 'product.material.stock', 'product.material.variant', 'product.material.features']
                                }
                            ]
                        },
                        {
                            link: '/services',
                            text: t('services', 'Servicios'),
                            component: Services,
                            permissions: 'product.service.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('service', 'Servicio'),
                                    component: SingleService,
                                    permissions: ['product.service.main', 'product.service.features', 'product.service.supplier', 'product.service.specificPrice', 'product.service.variant', 'product.service.productComposed', 'product.service.productAddon', 'product.service.otherInformation', 'product.service.web']
                                }
                            ]
                        },
                        {
                            link: '/adjustmentDeliveryNotes',
                            text: t('adjustmentsDeliveryNotes', 'Albaranes de regularización'),
                            component: AdjustmentDNs,
                            modules: ['quotes'],
                            permissions: 'adjustmentDeliveryNote',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('adjustmentDeliveryNotes', 'Albarán de regularización'),
                                    component: SingleAdjustmentDN,
                                    permissions: ['adjustmentDeliveryNote']
                                },
                            ]
                        },
                    ]
                },
                {
                    link: '/stock',
                    text: t('stock', 'Inventario'),
                    component: Warehouses,
                    permissions: 'warehouse.main',
                    modules: ['products'],
                    childs: [
                        {
                            link: '/warehouses',
                            text: t('warehouses', 'Almacenes'),
                            component: Warehouses,
                            permissions: 'warehouse.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('warehouse', 'Almacén'),
                                    component: SingleWarehouse,
                                    permissions: ['warehouse', 'warehouse.main', 'warehouse.stock']
                                }
                            ]
                        },
                    ]
                },
            ]
        },
        {
            link: '/buys',
            text: t('buys', 'Compras'),
            icon: faDolly,
            component: LogisticDashboard,
            modules: ['quotes'],
            childs: [
                {
                    link: '/buys',
                    text: t('buys', 'Compras'),
                    component: BuyOrders,
                    modules: ['quotes'],
                    childs: [
                        {
                            link: '/orders',
                            text: t('buyOrders', 'Pedidos'),
                            component: BuyOrders,
                            permissions: 'buy.order',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('buyOrders', 'Pedidos'),
                                    component: SingleBuyOrder,
                                    permissions: ['buy.order']
                                }
                            ]
                        },
                        {
                            link: '/deliveryNotes',
                            text: t('deliveryNotes', 'Albaranes'),
                            component: BuyDeliveryNotes,
                            permissions: 'buy.deliveryNote',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('deliveryNotes', 'Albaranes'),
                                    component: SingleBuyDeliveryNote,
                                    permissions: ['buy.deliveryNote']
                                },
                            ]
                        },
                        {
                            link: '/invoices',
                            text: t('invoices', 'Facturas'),
                            component: BuyInvoices,
                            permissions: 'buy.invoice',
                            childs: [
                                {
                                    link: '/single/:id',
                                    text: t('invoices', 'Facturas'),
                                    component: SingleBuyInvoice,
                                    permissions: ['buy.invoice']
                                }
                            ]
                        },
                        {
                            link: '/suppliers',
                            text: t('suppliers', 'Proveedores'),
                            component: Suppliers,
                            permissions: 'supplier.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('supplier', 'Proveedor'),
                                    component: SingleSupplier,
                                    permissions: ['supplier.main', 'supplier.tradeAgreements', 'supplier.service', 'supplier.files', 'supplier.bank', 'supplier.contactPersons', 'supplier.billingGroup']
                                }
                            ]
                        },
                    ]
                },
            ]
        },
        {
            link: '/finances',
            text: t('finances', 'Finanzas'),
            icon: faBooks,
            modules: ['quotes'],
            childs: [
                {
                    link: '/treasury',
                    text: t('treasury', 'Tesorería'),
                    childs: [
                        {
                            link: '/vatRepercuted',
                            text: t('vatRepercuted', 'IVAs Repercutidos'),
                            component: VatRepercuted,
                            permissions: 'accounting.vatRepercuted',
                            childs: [
                                {
                                    link: '/:id',
                                    text: t('vatRepercuted', 'IVA Repercutido'),
                                    component: SingleVatRepercuted,
                                    permissions: 'accounting.vatRepercuted'
                                }
                            ],
                        },
                        {
                            link: '/vatSupported',
                            text: t('vatSupporteds', 'IVAs Soportados'),
                            component: VatSupported,
                            permissions: 'accounting.vatSupported',
                            childs: [
                                {
                                    link: '/:id',
                                    text: t('vatSupported', 'IVA Soportado'),
                                    component: SingleVatSupported,
                                    permissions: 'accounting.vatSupported'
                                }
                            ]
                        },
                        {
                            link: '/payments',
                            text: t('collectionsAndPayments', 'Cobros y Pagos'),
                            component: CollectionAndPayments,
                            permissions: 'accounting.collectionsAndPayments',
                            childs: [
                                {
                                    link: '/remittances/:id',
                                    text: t('Remittances', 'Remesas'),
                                    component: Remittances,
                                    permissions: 'accounting.collectionsAndPayments'
                                }
                            ]
                        },
                        {
                            link: '/creditors',
                            text: t('creditors', 'Acreedores'),
                            component: Creditors,
                            permissions: 'creditor.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('supplier', 'Proveedor'),
                                    component: SingleCreditor,
                                    permissions: ['creditor.main', 'creditor.service', 'creditor.files', 'creditor.bank', 'creditor.contactPersons', 'creditor.tradeAgreements', 'creditor.billingGroup']
                                }
                            ]
                        },
                    ]
                },
            ]
        },
        {
            link: '/humanResources',
            text: t('RRHH', 'RRHH'),
            icon: faUsers,
            component: StaffDashboard,
            childs: [
                {
                    link: '/timeControl',
                    text: t('timeControl', 'Control horario'),
                    modules: ['working_calendar', 'working_calendar_medium', 'working_calendar_full'],
                    to: `${locations.timeControlCEWM}/${EmployeeId}/${now.getMonth() + 1}/${now.getFullYear()}`,
                    childs: [
                        {
                            link: '/controlEmployeesWorkingMonth/:EmployeeId/:month/:year',
                            to: `${locations.timeControlCEWM}/${EmployeeId}/${now.getMonth() + 1}/${now.getFullYear()}`,
                            text: t('controlWorkingMonth', 'Control calendario del mes'),
                            component: TimeControlEmployeeMonth,
                            permissions: 'WCal.checkEmployeeMonth'
                        },
                        {
                            link: '/workingCalendarTurns',
                            text: t('turns', 'Turnos'),
                            component: WorkingCalendarTurns,
                            permissions: 'WCal.turn',
                            modules: ['working_calendar_full']
                        },
                        {
                            link: '/workingCalendarHolidayRequests',
                            text: t('holidayListing', 'Listado de vacaciones'),
                            component: WorkingCalendarHolidayRequests,
                            permissions: 'WCal.holiday.usedDays',
                            modules: ['working_calendar_medium', 'working_calendar_full']
                        },
                        {
                            link: '/employeeAbsencesRequests',
                            text: t('absencesListing', 'Listado de ausencias'),
                            component: EmployeeAbsencesRequests,
                            permissions: 'WCal.absences.control',
                            modules: ['working_calendar_full']
                        },
                        {
                            link: '/workingCalendarOvertimeRequests',
                            text: t('overtimeListing', 'Listado de horas extra'),
                            component: WorkingCalendarOvertimeRequests,
                            permissions: 'WCal.overtime',
                            modules: ['working_calendar_full']
                        },
                        {
                            link: '/workingCalendarFree',
                            text: t('workingCalendarsFree', 'Calendarios de días festivos'),
                            component: WorkingCalendarFree,
                            permissions: 'WCal.free',
                            childs: [
                                {
                                    link: '/:id/:year',
                                    text: t('freeDays', 'Días festivos'),
                                    component: WorkingCalendarFreeDays,
                                    permissions: 'WCal.free'
                                }
                            ]
                        },
                        {
                            link: '/workingCalendarSpecialDays',
                            text: t('workingCalendarSpecialDays', 'Calendarios de días especiales'),
                            component: WorkingCalendarSpecial,
                            permissions: 'WCal.special',
                            modules: ['working_calendar_full'],
                            childs: [
                                {
                                    link: '/:id/:year',
                                    text: t('specialDays', 'Días especiales'),
                                    component: WorkingCalendarSpecialDays,
                                    permissions: 'WCal.special'
                                }
                            ]
                        },
                        {
                            link: '/workingCalendarHolidayBag',
                            text: t('holidayBag', 'Bolsa de vacaciones'),
                            component: WorkingCalendarHolidayBag,
                            permissions: 'WCal.holiday.bags',
                            modules: ['working_calendar_medium', 'working_calendar_full']
                        },
                        {
                            link: '/generateQr',
                            text: t('generateQr', 'Generar códigos Qr'),
                            component: GenerateQrCodes,
                            permissions: 'generateQRCodes',
                            modules: ['working_calendar', 'working_calendar_medium', 'working_calendar_full']
                        },
                    ]
                },
                {
                    link: '/expenses',
                    text: t('expenses', 'Gastos'),
                    modules: ['employee_expenses'],
                    component: ExpensesRequest,
                    childs: [
                        {
                            link: '/expensesRequests',
                            text: t('expensesListing', 'Listado de gastos'),
                            component: ExpensesRequest,
                            permissions: 'expenses.main',
                        },
                    ]
                },
                {
                    link: '/bases',
                    text: t('employees', 'Empleados'),
                    to: locations.employees,
                    childs: [
                        {
                            link: '/employees',
                            text: t('employees', 'Empleados'),
                            component: Employees,
                            permissions: 'employee.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('employee', 'Empleado'),
                                    component: SingleEmployee,
                                    permissions: ['employee.main', 'employee.files', 'employee.holidays', 'employee.absences', 'employee.payslip', 'employee.expenses', 'employee.notes', 'employee.agreementHours']
                                }
                            ]
                        },
                    ]
                },
                {
                    link: '/sue',
                    text: t('ethicalCannel', 'Canal Ético'),
                    component: Sues,
                    permissions: 'sue',
                    modules: ['sue'],
                    childs: [
                        {
                            link: '/sues',
                            text: t('ethicalCannel', 'Canal Ético'),
                            component: Sues,
                            permissions: 'sue',
                        },
                    ]
                },
            ]
        },
        {
            link: '/config',
            text: t('configShort', 'Config.'),
            icon: faCog,
            to: locations.config,
            childs: [
                {
                    link: '/app',
                    text: t('general', 'General'),
                    to: locations.configApp,
                    childs: [
                        {
                            link: '/parameters/:tab',
                            to: locations.parameters,
                            text: t('parameters', 'Parámetros'),
                            component: ConfigParameters,
                            permissions: ['config.parameter']
                        },
                        {
                            link: '/groups',
                            text: t('employeesGroups', 'Grupos de Empleados'),
                            component: GroupEmployees,
                            permissions: 'group.main',
                            childs: [
                                {
                                    link: '/:id',
                                    text: t('permission', 'Permisos'),
                                    component: PermissionGroup,
                                    permissions: ['group.permissions']
                                }
                            ]
                        },
                        {
                            link: '/workingCenters',
                            text: t('workingCenters', 'Centros de trabajo'),
                            component: WorkingCenters,
                            permissions: 'workingCenter.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('workingCenter', 'Centro de trabajo'),
                                    component: SingleWorkingCenter,
                                    permissions: ['workingCenter', 'workingCenter.employee', 'workingCenter.main', 'workingCenter.counter', 'workingCenter.warehouse', 'workingCenter.shippingService', 'workingCenter.bank', 'workingCenter.station', 'workingCenter.shift4Device']
                                }
                            ]
                        },
                        {
                            link: '/currency',
                            text: t('currencies', 'Monedas'),
                            component: ConfigCurrencies,
                            permissions: 'config.currency'
                        },
                        {
                            link: '/lang',
                            text: t('languages', 'Idiomas'),
                            component: ConfigLangs,
                            permissions: 'config.lang'
                        },
                        {
                            link: '/vats',
                            text: t('vats', 'Impuestos'),
                            component: ConfigGroupVats,
                            permissions: 'config.vat',
                            modules: ['products'],
                            childs: [
                                {
                                    link: '/:GroupVatId',
                                    text: t('vat', 'Impuesto'),
                                    component: ConfigSingleVat,
                                    permissions: 'config.vat',
                                }
                            ]
                        },
                        {
                            link: '/pdfTemplates',
                            text: t('docTemplates', 'Plantillas de documentos'),
                            component: ConfigPdfTemplates,
                            permissions: 'config.pdfTemplate',
                            childs: [
                                {
                                    link: '/:id',
                                    text: t('docTemplate', 'Plantilla de documento'),
                                    component: ConfigPdfTemplateSingle,
                                    permissions: 'config.pdfTemplate',
                                }
                            ]
                        },
                        {
                            link: '/csvOrderTemplates',
                            text: t('exportTemplates', 'Plantillas de exportación'),
                            component: ConfigCsvOrderTemplates,
                            permissions: 'config.pdfTemplate',
                        },
                        {
                            link: '/labels',
                            text: t('labelTemplates', 'Plantillas de etiquetas'),
                            component: ConfigLabels,
                            permissions: 'config.label',
                        },
                        {
                            link: '/userLogs',
                            text: t('accessLogs', 'Registro de accesos'),
                            component: UsersLogs,
                            permissions: 'logs',
                        }
                    ]
                },
                {
                    link: '/customers',
                    text: t('customers', 'Clientes'),
                    to: locations.configCustomers,
                    childs: [
                        {
                            link: '/groups',
                            text: t('groupsCustomers', 'Grupos de clientes'),
                            component: GroupsCustomers,
                            permissions: 'customer.customerGroup',
                            modules: ['tasks']
                        },
                        {
                            link: '/origins',
                            text: t('customerOrigins', 'Orígenes de cliente'),
                            component: CustomerOrigins,
                            permissions: 'customer.origin',
                        },
                        {
                            link: '/projectTypes/:CustomerProjectTypeId',
                            text: t('customerProjectTypes', 'Tipos de proyecto'),
                            component: CustomerProjectTypes,
                            permissions: 'customer.customerProjectType',
                            to: locations.projectTypesMain,
                            modules: ['tasks']
                        },
                        {
                            link: '/templateChecklist',
                            text: t('templateProjectList', 'Plantilla lista de proyecto'),
                            component: ConfigTemplateChecklists,
                            permissions: 'config.customerProject.templateChecklist'
                        },
                    ]
                },
                {
                    link: '/tasks',
                    text: t('tasks', 'Tareas'),
                    to: locations.configTasks,
                    modules: ['tasks'],
                    childs: [
                        {
                            link: '/customFields/:TaskCFieldId',
                            text: t('customFields', 'Campos personalizados'),
                            component: TaskCustomFields,
                            permissions: 'task.CField',
                            to: locations.customFieldsMain
                        },
                        {
                            link: '/taskTypes',
                            text: t('taskTypes', 'Tipos de tarea'),
                            component: TaskTypes,
                            permissions: 'task.taskType',
                        },
                        {
                            link: '/taskRepositoryTags',
                            text: t('repositoryTags', 'Etiquetas de repositorio'),
                            component: TaskRespositoryTags,
                            permissions: 'task.repository',
                        },
                    ]
                },
                {
                    link: '/humanResources',
                    text: t('humanResources', 'Recursos humanos'),
                    to: locations.configHumanResources,
                    modules: ['working_calendar', 'working_calendar_medium', 'working_calendar_full'],
                    childs: [
                        {
                            link: '/workingCalendars',
                            text: t('workingCalendars', 'Calendarios laborales'),
                            component: WorkingCalendars,
                            permissions: 'WCal.main',
                            childs: [
                                {
                                    link: '/:id/:tab',
                                    text: t('workingCalendar', 'Calendario laboral'),
                                    component: SingleWorkingCalendar,
                                    permissions: ['WCal.main', 'WCal.schedule']
                                }
                            ]
                        },
                        {
                            link: '/employeeAbsenceTypes',
                            text: t('employeeAbsenceTypes', 'Tipos de ausencia'),
                            component: EmployeeAbsenceTypes,
                            permissions: 'WCal.absences.type',
                            modules: ['working_calendar_full']
                        },
                        {
                            link: '/expensesTypes',
                            text: t('expensesTypes', 'Tipos de gastos'),
                            component: ExpensesTypes,
                            permissions: 'expenses.rowType'
                        },
                    ]
                },
                {
                    link: '/products',
                    text: t('products', 'Productos'),
                    to: locations.configProducts,
                    modules: ['products'],
                    childs: [
                        {
                            link: '/categories',
                            text: t('categories', 'Categorías'),
                            component: Categories,
                            permissions: 'product.category',
                            to: locations.categories,
                            childs: [
                                {
                                    link: '/:CategoryId',
                                    text: t('categories', 'Categorías'),
                                    component: Categories,
                                    permissions: 'product.category',
                                }
                            ]
                        },
                        {
                            link: '/categoriesMaterial',
                            text: t('categoriesMaterial', 'Categorías de Materiales'),
                            component: MaterialCategories,
                            permissions: 'product.materialCategory',
                            to: locations.categoriesMaterial,
                            childs: [
                                {
                                    link: '/:CategoryId',
                                    text: t('categoriesMaterial', 'Categorías de Materiales'),
                                    component: MaterialCategories,
                                    permissions: 'product.materialCategory',
                                }
                            ]
                        },
                        {
                            link: '/categoriesAddons',
                            text: t('categoriesAddons', 'Categorías de complementos'),
                            component: AddonCategories,
                            permissions: 'product.addonCategory',
                            to: locations.categoriesAddons,
                            childs: [
                                {
                                    link: '/:CategoryId',
                                    text: t('categoriesAddons', 'Categorías de complementos'),
                                    component: AddonCategories,
                                    permissions: 'product.addonCategory',
                                }
                            ]
                        },
                        {
                            link: '/features/:FeatureId',
                            text: t('features', 'Características'),
                            component: Features,
                            permissions: 'product.features',
                            to: locations.features
                        },
                        {
                            link: '/variants/:VariantId',
                            text: t('variants', 'Variantes'),
                            component: Variants,
                            permissions: 'product.variant',
                            to: locations.variants,
                        },
                        {
                            link: '/priceRules',
                            text: t('rateGroups', 'Grupos de tarifas'),
                            component: SpecificPriceRules,
                            permissions: 'product.specificPriceRules'
                        },
                        {
                            link: '/priceZones/:PriceZoneGroupId',
                            text: t('priceZones', 'Zonas de precios'),
                            component: PriceZones,
                            permissions: 'product.priceZone',
                            to: locations.priceZones,
                        },
                        {
                            link: '/brands',
                            text: t('brands', 'Marcas'),
                            component: Brands,
                            permissions: 'product.brand',
                        },
                        {
                            link: '/collections',
                            text: t('collections', 'Colecciones'),
                            component: Collections,
                            permissions: 'product.collection',
                        },
                        {
                            link: '/productTypes',
                            text: t('productTypes', 'Tipos de producto'),
                            component: ProductTypes,
                            permissions: 'product.type',
                        }
                    ]
                },
                {
                    link: '/logistic',
                    text: t('logistic', 'Logística'),
                    to: locations.configLogistic,
                    modules: ['quotes'],
                    childs: [
                        {
                            link: '/costsSell',
                            text: t('costsSell', 'Costes de ventas'),
                            component: ConfigCostSells,
                            modules: ['quotes'],
                            permissions: 'config.cost'
                        },
                        {
                            link: '/costBuy',
                            text: t('costBuys', 'Costes de compras'),
                            component: ConfigCostBuys,
                            modules: ['quotes'],
                            permissions: 'config.cost'
                        },
                        {
                            link: '/shippingZones/:ShippingZoneGroupId',
                            text: t('shippingZones', 'Zonas de envíos'),
                            component: ConfigShippingZones,
                            modules: ['quotes'],
                            permissions: 'config.shipping.shippingZone',
                            to: locations.shippingZonesMain
                        },
                        {
                            link: '/shippingCompanies/:ShippingCompanyId',
                            text: t('shippingCompanies', 'Transportistas'),
                            component: ConfigShippingCompanies,
                            modules: ['quotes'],
                            permissions: 'config.shipping.shippingCompany',
                            to: locations.shippingCompaniesMain,
                            childs: [
                                {
                                    link: '/services/:ShippingServiceId',
                                    text: t('shippingService', 'Servicio'),
                                    component: SingleConfigShippingServiceConnect,
                                    permissions: 'config.shipping.shippingCompany',
                                }
                            ]
                        },
                        {
                            link: '/sellVariables',
                            text: t('sellVariables', 'Variables de venta'),
                            component: ConfigSellVariables,
                            modules: ['quotes'],
                            permissions: 'config.sellVariable'
                        },
                        {
                            link: '/serviceType',
                            text: t('serviceTypes', 'Tipos de servicio'),
                            component: ConfigServiceTypes,
                            modules: ['quotes'],
                            permissions: 'config.serviceType'
                        },
                        {
                            link: '/billingGroups',
                            text: t('billingGroups', 'Grupos de Facturación'),
                            modules: ['quotes'],
                            component: ConfigBillingGroups,
                            permissions: 'config.billingGroup',
                            childs: [
                                {
                                    link: '/billingTypeBuy/:BillingGroupId/:BillingTypeBuyId',
                                    text: t('billingTypesBuy', 'Tipos de facturación Compra'),
                                    component: ConfigBillingTypesBuy,
                                    permissions: 'config.billingGroup',
                                    to: '/main',
                                },
                                {
                                    link: '/billingTypeSell/:BillingGroupId/:BillingTypeSellId',
                                    text: t('billingTypesSell', 'Tipos de facturación Compra'),
                                    component: ConfigBillingTypesSell,
                                    permissions: 'config.billingGroup',
                                    to: '/main',
                                },
                                {
                                    link: '/billingRetention/:BillingGroupId',
                                    text: t('billingTypes', 'Tipos de facturación'),
                                    component: ConfigBillingRetentions,
                                    permissions: 'config.billingGroup',
                                },
                            ]
                        },
                        {
                            link: '/sellTags',
                            text: t('sellTags', 'Etiquetas de ventas'),
                            component: SellTags,
                            permissions: 'sell.tags'
                        },
                        {
                            link: '/workSheetGroupStatus/:WorkSheetGroupStatusId',
                            text: t('workSheetGroup', 'Grupos de hojas de trabajo'),
                            component: WorkSheetGroupStatus,
                            permissions: 'config.workSheetGroupStatus',
                            to: locations.workSheetGroupStatusMain
                        },
                        {
                            link: '/buyTags',
                            text: t('buyTags', 'Etiquetas de compra'),
                            component: BuyTags,
                            permissions: 'buy.tags'
                        },
                        {
                            link: '/paymentMethods',
                            text: t('paymentMethods', 'Métodos de pago'),
                            component: ConfigPaymentMethods,
                            permissions: 'config.payment'
                        },
                        {
                            link: '/paymentTypes',
                            text: t('paymentTypes', 'Tipos de pago'),
                            component: ConfigPaymentTypes,
                            permissions: 'config.payment'
                        },
                    ]
                }
            ]
        },
        {
            link: '/',
            text: t('main', 'Principal'),
            icon: faHomeLgAlt,
            component: CompanyDashboard,
        },
        {
            link: '/employeeProfile/:tab',
            text: t('employee', 'Empleado'),
            component: EmployeeProfile,
        },
        {
            link: '/timeControl/:tab',
            text: t('timeControl', 'Control horario'),
            component: UserTimeControl,
            modules: ['working_calendar', 'working_calendar_medium', 'working_calendar_full'],
        },
        {
            link: '/notifications/:tab',
            text: t('notifcations', 'Notificaciones'),
            component: Notifications,
        },
        {
            link: '/activateDevice/:fingerprint_token',
            text: 'Activate',
            component: ActivateFingerprintInner
        },
        {
            link: '/fixWCal/',
            text: 'fixWCal',
            component: FixWCal,
            modules: ['working_calendar', 'working_calendar_medium', 'working_calendar_full'],
            permissions: 'no_one_have_this' as any
        }
    ]
}

export interface ErpRoutesProps extends ReduxErpRoutesConnector {

};

const ErpRoutes: React.FC<ErpRoutesProps> = ({ groupPermissions, modulesBuyed, modulesDemo, EmployeeId, bookMarkRoutes }) => {
    const {t} = useTwinTranslation()
    const bookMarkRoutesParsedDict = useMemo(() => {
        if(!bookMarkRoutes){
            return undefined
        }
        const result: BookMarkRoutesParsedTy = {}
        const parsed = JSON.parse(bookMarkRoutes)
        for (const key in parsed) {
            const element = parsed[key]
            result[element.link] = {...element, key}
        }
        return result
    }, [bookMarkRoutes])
    const routes = ErpRoutesPaths(EmployeeId)
    const {routeParsed, bookMarkParsed } = cleanRoutes(routes, groupPermissions, modulesBuyed, modulesDemo, undefined, bookMarkRoutesParsedDict)
    let alreadyPushed: TwinDictionary = {}
    if (bookMarkParsed?.length) {
        const myChilds = []
        for (const element of bookMarkParsed) {
            if(!alreadyPushed[element.link]){
                myChilds.push(element)
                alreadyPushed[element.link] = element.link
            }
        }
        routeParsed.unshift({
            icon: faBookmark,
            link: '__bookmark',
            text: t('bookmarks', 'Marcadores'),
            childs: [
                {
                    text: t('yourBookmarks', 'Tus marcadores'),
                    link: '__bookmark',
                    childs: myChilds.sort((a, b) => a.key - b.key)
                }
            ]
        })
    }
    return <AppLayoutLoaded routes={routeParsed} bookMarkParsed={bookMarkParsed} bookMarkParsedDict={bookMarkRoutesParsedDict}><CreateRoutering routes={routeParsed}></CreateRoutering></AppLayoutLoaded>
}

const mapErpRoutesConnector = (state: AllReduxAppPayloads) => ({ groupPermissions: state.user?.extraData.groupPermissions, modulesBuyed: state.company?.modulesBuyed, modulesDemo: state.company?.modulesDemo, EmployeeId: state?.user?.extraData?.Employee?.id, bookMarkRoutes: state?.user?.extraData?.Employee?.EmployeeParameters?.bookMarkRoutes })
export const erpRoutesConnector = connect(mapErpRoutesConnector, null, null, { context: GlobalContext })
export type ReduxErpRoutesConnector = ConnectedProps<typeof erpRoutesConnector>


const ErpRoutesConnector = erpRoutesConnector(ErpRoutes)

const ErpRoutesLoader: React.FC = () => {
    return (<ErpLoader><ErpRoutesConnector /></ErpLoader>)
}

export default ErpRoutesLoader